<template>
  <div class="cancellation" data-testid="cancellation">
    <HeadingDisplay
      class="cancellation__title"
      :title="pageData.summary.cancellationSection.title"
      size="medium"
    />
    <BaseText class="cancellation__text">
      {{ pageData.summary.cancellationSection.description }}
    </BaseText>
    <ButtonPrimary
      :label="pageData.summary.cancellationSection.buttonLabel"
      @click="handleRLPCancellation"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import {
  HeadingDisplay,
  BaseText,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import {
  RLPPageData,
  RLPStatus,
  updateRLPStatus,
  UpdateRLPStatusValues
} from '@/modules/trade/services/rlp';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

interface Props {
  pageData: RLPPageData;
}
const props = defineProps<Props>();

interface Emits {
  (e: 'on-cancellation'): void;
  (e: 'refresh'): void;
}
const emit = defineEmits<Emits>();

const isLoading = ref(false);

const handleRLPCancellation = async () => {
  if (props.pageData.form.cancellation) return emit('on-cancellation');

  try {
    isLoading.value = true;

    const data = await updateRLPStatus(UpdateRLPStatusValues.disable);

    notify({
      group: 'wrn-notifications',
      text: data.message,
      type:
        data.status === RLPStatus.Inactive
          ? NotificationTypes.success
          : NotificationTypes.info,
      duration: 6000
    });
    emit('refresh');
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível desativar o Warren RLP. Aguarde um momento e tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
  }
};
</script>

<style lang="less" scoped>
.cancellation {
  &__text {
    margin: @size-spacing-x400 0;
  }
}
</style>
